import { flushSync } from 'react-dom';

/**
 * Wraps a state update in a View Transition if supported.
 * Falls back to instant swap on older browsers.
 */
export function viewTransition(update: () => void): void {
  if (!document.startViewTransition) {
    update();
    return;
  }
  document.startViewTransition(() => flushSync(update));
}
